import { render, staticRenderFns } from "./TextAreaInputModal.vue?vue&type=template&id=11058d40&"
import script from "./TextAreaInputModal.vue?vue&type=script&lang=js&"
export * from "./TextAreaInputModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports